const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// TODO: could we make this 'ActiveSampleRecord' and use to edit samples too?
		this.CurrentSampleRecord = {};
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// set the customer ID if it exists
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser.CustomerID || 0;
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Enter a project...',
			ElementID: 'SampleCreate-Entry-Project',
			ParentID: 'SampleCreate-Container',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// MATERIAL Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a material..',
			ElementID: 'SampleCreate-Entry-Material',
			ParentID: 'SampleCreate-Container',
			URL: 'Materials',
			IDField: 'IDMaterial',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Materials initialized');
		});

		// MIX Design Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a mix Design...',
			ElementID: 'SampleCreate-Entry-MixDesign',
			ParentID: 'SampleCreate-Container',
			URL: 'MixDesigns',
			IDField: 'IDMixDesign',
			TextField: 'MixID',
		}, () =>
		{
			this.log.info('Select2 Mix Designs initialized');
		});

		// PRODUCER Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a producer...',
			ElementID: 'SampleCreate-Entry-Producer',
			ParentID: 'SampleCreate-Container',
			URL: 'Organizations',
			IDField: 'IDOrganization',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Producers initialized');
		});

		// PRODUCT Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a product...',
			ElementID: 'SampleCreate-Entry-Product',
			ParentID: 'SampleCreate-Container',
			URL: 'Products',
			IDField: 'IDProduct',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Products initialized');
		});

		// PLANT Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a plant...',
			ElementID: 'SampleCreate-Entry-Plant',
			ParentID: 'SampleCreate-Container',
			URL: 'ProductionPlants',
			IDField: 'IDProductionPlant',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Plants initialized');
		});

		// LAB Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a lab...',
			ElementID: 'SampleCreate-Entry-Lab',
			ParentID: 'SampleCreate-Container',
			URL: 'Labs',
			IDField: 'IDLab',
			TextField: 'Name',
			minimumInputLength: 0,
		}, () =>
		{
			this.log.info('Select2 Labs initialized');
		});

		//  DESIGNATEDDATE date picker
		window.flatpickr('#SampleCreate-Entry-Date', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleCreate-Date');
			},
		});

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.SampleCreate.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.SampleCreate.CurrentSearchFilters.PageSize : data.length === _Pict.views.SampleCreate.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method updates the current sample record with the value of the specified field.
	 * @param {string} id - The id of the element to get the value from.
	 * @param {string} pField - The field to update in the current sample record.
	 * @return {void}
	 */
	handleNewSampleRecordChange(id, pField)
	{
		const tmpElement = document.getElementById(id);
		if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLTextAreaElement || tmpElement instanceof HTMLSelectElement)
		{
			this.CurrentSampleRecord[pField] = tmpElement.value;
			this.log.info(`Current Sample Record updated: ${pField} = ${this.CurrentSampleRecord[pField]}`);
		}
	}

	/**
	 * This method clears the current sample record.
	 * @return {void}
	 */
	clearSample()
	{
		this.CurrentSampleRecord = {};
		this.renderAsync(() =>
		{
			this.log.info('Sample Create view cleared');
		});
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.CurrentSampleRecord));

		const tmpSampleRecord = {};
		Object.keys(this.CurrentSampleRecord).forEach((pKey) =>
		{
			switch (pKey)
			{
			case 'Date':
				tmpSampleRecord.DesignatedTime = this.CurrentSampleRecord.Date ? this.fable.Dates.dayJS(this.CurrentSampleRecord.Date).toISOString() : null;
				break;
			case 'Project':
				tmpSampleRecord.IDProject = this.CurrentSampleRecord.Project;
				break;
			case 'Material':
				tmpSampleRecord.IDMaterial = this.CurrentSampleRecord.Material;
				break;
			case 'MixDesign':
				tmpSampleRecord.IDMixDesign = this.CurrentSampleRecord.MixDesign;
				break;
			case 'Producer':
				tmpSampleRecord.IDOrganization = this.CurrentSampleRecord.Producer;
				break;
			case 'Product':
				tmpSampleRecord.IDProduct = this.CurrentSampleRecord.Product;
				break;
			case 'Plant':
				tmpSampleRecord.IDProductionPlant = this.CurrentSampleRecord.Plant;
				break;
			case 'Quantity':
				tmpSampleRecord.RepresentedQuantity = this.CurrentSampleRecord.Quantity;
				break;
			case 'Units':
				tmpSampleRecord.RepresentedQuantityUnits = this.CurrentSampleRecord.Units;
				break;
			case 'Notes':
				tmpSampleRecord.Notes = this.CurrentSampleRecord.Notes;
				break;
			case 'Name':
				tmpSampleRecord.Name = this.CurrentSampleRecord.Name;
				break;
			case 'IntendedUse':
				tmpSampleRecord.IntendedUse = this.CurrentSampleRecord.IntendedUse;
				break;
			case 'ManufacturerCode':
				tmpSampleRecord.ManufacturerCode = this.CurrentSampleRecord.ManufacturerCode;
				break;
			case 'Lab':
				// TODO: Lab is not set on the record?, may have to remove this line
				//tmpSampleRecord.IDLab = this.CurrentSampleRecord.Lab;
				break;
			case 'SampleType':
				// TODO: SampleType is not set on the record?, may have to remove this line
				//tmpSampleRecord.SampleType = this.CurrentSampleRecord.SampleType;
				break;
			default:
				tmpSampleRecord[pKey] = this.CurrentSampleRecord[pKey];
				break;
			}
		});

		try
		{
			const pResult = await this.pict.providers.SampleProvider.createSample(tmpSampleRecord);
			this.log.info('Sample created, going to the Details view...');

			// if we are in add mode, we need to update the selector to show the new sample
			// NOTE: Need to do this first before we swap panels since Details view doesn't have an "add mode" (yet)
			if (this.pict.ContentAssignment.readAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode') === 'add-to-set')
			{
				// TODO: This assumes search panel is already rendered, which it is, but we should revisit if we change that
				this.pict.views.SampleSearch.sampleSelectionCallback(pResult);
				this.pict.views.HeadlightPanels.closeAllPanels();
				this.pict.views.HeadlightPanels.toast({ message: 'Sample created and added to the input selector.', type: 'is-success' });
			}

			// show the details view for the new sample
			this.pict.views.SampleDetails.showSampleDetailView(pResult.IDSample, null, 'Details');
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
		}
	}
}

module.exports = SampleCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleCreate',
	DefaultRenderable: 'SampleCreate',
	DefaultDestinationAddress: '#SampleCreate-Container',
	Templates:
	[
		{
			Hash: 'SampleCreate',
			Template: /*html*/`
			{~T:SampleCreate-Entry~}`,
		},
		{
			Hash: 'SampleCreate-Entry',
			Template: /*html*/`
			<form id="SampleCreate-Form" onsubmit="_Pict.views.SampleCreate.createNewSample(event)">
				<div class="columns px-4 my-0">
					{~T:SampleCreate-Entry-NameInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ProjectSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-MixDesignSelector~}
					{~T:SampleCreate-Entry-MaterialSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ProducerSelector~}
					{~T:SampleCreate-Entry-ProductSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-PlantSelector~}
					{~T:SampleCreate-Entry-QuantityInput~}
					{~T:SampleCreate-Entry-UnitsInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ManufacturerCodeInput~}
					{~T:SampleCreate-Entry-IndendedUseInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-NotesInput~}
				</div>
				<div class="columns px-4 mb-0 mt-1">
					<div class="column">
						<div class="buttons is-right">
							<button type="button" class="button is-primary is-soft" title="Clear sample" onclick="_Pict.views.SampleCreate.clearSample()">
								<span class="icon">
									<i class="fa fa-fw fa-refresh"></i>
								</span>
								<span class="icon-text">Clear</span>
							</button>
							<button type="submit" class="button is-primary" title="Create new sample">
								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span class="icon-text">Create New Sample</span>
							</button>
						</div>
					</div>
				</div>
			</form>`,
		},
		{
			Hash: 'SampleCreate-Entry-NameInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Name">Sample Name</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Name" 
							class="input" 
							type="text" 
							placeholder="Enter a name for the sample..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Name')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-DateInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Date">Sample Date</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Date" 
							class="input" 
							type="date" 
							placeholder="Enter a date for the sample..." 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Date')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-SampleTypeInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-SampleType">Sample Type</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-SampleType" 
							class="input" 
							type="text" 
							value="Acceptance" 
							placeholder="Enter a type for the sample..."
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'SampleType')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-QuantityInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Quantity">Rep. Quantity</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Quantity" 
							class="input" 
							type="number" 
							value="0.000" 
							placeholder="Enter a Quantity for the sample..." 
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Quantity')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-UnitsInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Units">Units</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Units" 
							class="input" 
							type="text" 
							value="" 
							placeholder="Variable Units (English)"
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Units')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ManufacturerCodeInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-ManufacturerCode">Manufacturer Code</label>
					<div class="control">
						<input
							id="SampleCreate-Entry-ManufacturerCode"
							class="input"
							type="text"
							value=""
							placeholder="Enter a manufacturer code..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'ManufacturerCode')"
							/>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-IndendedUseInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-IndendedUse">Intended Use</label>
					<div class="control">
						<input
							id="SampleCreate-Entry-IndendedUse"
							class="input"
							type="text"
							value=""
							placeholder="Enter the intended use..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'IntendedUse')"
							/>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-NotesInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Notes">Notes</label>
					<div class="control">
						<textarea 
							id="SampleCreate-Entry-Notes" 
							class="textarea" 
							placeholder="Enter any notes for the sample..."
							rows="2" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Notes')"
						></textarea>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProjectSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Project">Project</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-Project" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Project')"
						>{~TS:SampleCreate-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Enty-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-MaterialSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Material">Material</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-Material" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Material')"
						>{~TS:SampleCreate-Entry~MaterialSelector-SelectedOptions:Context[0].CurrentSearchFilters.Material~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-MaterialSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDMaterial~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-MixDesignSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-MixDesign">Mix Designs</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-MixDesign" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'MixDesign')"
						>{~TS:SampleCreate-Entry~MixDesignSelector-SelectedOptions:Context[0].CurrentSearchFilters.MixDesign~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-MixDesignSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDMixDesign~}" selected>{~D:Record.MixID~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProducerSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Producer">Producer</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Producer"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Producer')"
						>{~TS:SampleCreate-Entry~ProducerSelector-SelectedOptions:Context[0].CurrentSearchFilters.Producer~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProducerSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDOrganization~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProductSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Product">Product</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Product"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Product')"
						>{~TS:SampleCreate-Entry~ProductSelector-SelectedOptions:Context[0].CurrentSearchFilters.Product~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProductSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProduct~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-PlantSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Plant">Plant</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Plant"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Plant')"
						>{~TS:SampleCreate-Entry~PlantSelector-SelectedOptions:Context[0].CurrentSearchFilters.Plant~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-PlantSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProductionPlant~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-LabSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Lab">Destination Lab</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Lab"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Lab')"
						>{~TS:SampleCreate-Entry~LabSelector-SelectedOptions:Context[0].CurrentSearchFilters.Lab~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-LabSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDLab~}" selected>{~D:Record.Name~}</option>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleCreate',
			TemplateHash: 'SampleCreate',
			DestinationAddress: '#SampleCreate-Container',
			RenderType: 'replace',
		},
	],
};
